<script>
import { infoComputed, infoDetailsComputed } from '@state/helpers'

export default {
  data() {
    return {
      tabIndex: 9,
    }
  },

  computed: {
    ...infoComputed,
    ...infoDetailsComputed,
  },
}
</script>

<template>
  <b-tabs v-model="tabIndex" class="info-side h-100">
    <b-tab v-if="selectedFiltersDate" :key="2">
      <template slot="title">
        DATE
      </template>
      <BaseInfoSideFiltersDate />
    </b-tab>

    <b-tab v-if="selectedFiltersDeviceState" :key="3">
      <template slot="title">
        <i class="icon-magnifier"></i>
      </template>
      <BaseInfoSideFiltersDeviceState />
    </b-tab>

    <b-tab v-if="selectedFiltersDeviceStateHistory" :key="4">
      <template slot="title">
        <i class="icon-magnifier"></i>
      </template>
      <BaseInfoSideFiltersDeviceStateHistory />
    </b-tab>

    <b-tab v-if="selectedFiltersCycle" :key="5">
      <template slot="title">
        <i class="icon-magnifier"></i>
      </template>
      <BaseInfoSideFiltersCycle />
    </b-tab>

    <b-tab v-if="selectedFiltersActivity" :key="6">
      <template slot="title">
        <i class="icon-magnifier"></i>
      </template>
      <BaseInfoSideFiltersActivity />
    </b-tab>

    <b-tab v-if="selectedFiltersActivity" :key="6">
      <template slot="title">
        <i class="icon-magnifier"></i>
      </template>
      <BaseInfoSideFiltersActivity />
    </b-tab>

    <b-tab v-if="selectedFiltersEdge" :key="7">
      <template slot="title">
        <i class="icon-magnifier"></i>
      </template>
      <BaseInfoSideFiltersEdge />
    </b-tab>

    <b-tab v-if="selectedFiltersInsights" :key="8">
      <template slot="title">
        <i class="icon-list"></i>
      </template>
      <BaseInfoSideFiltersInsights />
    </b-tab>

    <b-tab v-if="selectedFiltersDevice" :key="9">
      <template slot="title">
        DEVICE
      </template>
      <BaseInfoSideDetailsDeviceStateHistoryDetailInteractDevice />
    </b-tab>

    <b-tab v-if="selectedDetails && selectedDefaultObject" :key="10" active>
      <template slot="title">
        <i class="icon-info"></i>
      </template>
      <BaseInfoSideDetails />
    </b-tab>
  </b-tabs>
</template>

<style lang="css">
.info-side .nav-link {
    --border-left: 0;

    font-size:1.09375rem !important;
    color:#666666 !important;
    border-radius: 2px !important;
}
</style>
